import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.53238 5L10.5725 11.7335C10.8522 12.1997 11 12.7333 11 13.277V20H13V13.277C13 12.7333 13.1478 12.1997 13.4275 11.7335L17.4676 5H6.53238ZM4.76619 3H19.2338C20.0111 3 20.4912 3.84797 20.0913 4.5145L15.1425 12.7625C15.0493 12.9179 15 13.0957 15 13.277V21C15 21.5523 14.5523 22 14 22H10C9.44772 22 9 21.5523 9 21V13.277C9 13.0957 8.95074 12.9179 8.85749 12.7625L3.9087 4.5145C3.50879 3.84797 3.9889 3 4.76619 3Z"
  }));
});
var ActionsFilter = AbstractIcon.withComponent(Icon);
ActionsFilter.displayName = 'ActionsFilter';
export default ActionsFilter;